import {
  Component,
  ElementRef,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { BaseService } from "../base.service";
import { environment } from "./../../../environments/environment";
import { ToastrService } from "ngx-toastr";
import { NgxSpinnerService } from "ngx-spinner";
import { Router } from "@angular/router";
import { FormControl } from "@angular/forms";
import { forkJoin, Observable } from "rxjs";
import { map, startWith } from "rxjs/operators";
import { MatAutocompleteTrigger } from "@angular/material/autocomplete";

export interface User {
  text: string;
  is_deleted: string;
}

@Component({
  selector: "app-search-page",
  templateUrl: "./search-page.component.html",
  styleUrls: ["./search-page.component.css"],
})
export class SearchPageComponent implements OnInit {
  moviesSpinner = false;
  myControl = new FormControl();
  options = [];
  moviesData = [];
  seriesData = [];
  albumData = [];
  count = 0;
  searchBox = false;
  filteredOptions: Observable<User[]>;
  // tslint:disable-next-line: variable-name
  recentSearchContent: Array<any>;
  // tslint:disable-next-line: variable-name
  upcomingContent: Array<any>;
  // tslint:disable-next-line: variable-name
  latestMoviesContent: Array<any>;
  // tslint:disable-next-line: varlatestMoviesContentable-name
  searchContent: any = [];
  // tslint:disable-next-line: variable-name
  searchCount: number;
  // tslint:disable-next-line: variable-name
  isSearch: boolean;
  searchStatus: boolean;
  // tslint:disable-next-line: variable-name
  appConstants: any;
  shimmerStatus = {
    upcommingShow: true,
    latest: true,
    search: true,
    isResent: true,
    genere: true,
    language: true,
  };
  model: any = { search_value: "" };
  recentVideo: Array<any> = [];
  recentdata: Array<any> = [];
  genereContent: any;
  languageData: any;
  next_data: any;
  responseData: any = { results: [] };
  @ViewChild(MatAutocompleteTrigger) autoTrigger: MatAutocompleteTrigger;
  @ViewChild("searchFocus") searchFocus: ElementRef;
  constructor(
    private pagesService: BaseService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private router: Router
  ) {
    this.appConstants = environment;
    if (localStorage.getItem("recentVideo")) {
      this.recentdata = JSON.parse(localStorage.getItem("recentVideo"));
    }
  }
  @Output() opened: EventEmitter<boolean> = new EventEmitter();
  @Output() closed: EventEmitter<boolean> = new EventEmitter();
  ngOnInit(): void {
    // this.getSuggationData('');
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 50);
    // this.getUpcomingData();filteredOptions
    // this.getLatestMoviesData();
    this.getGenereData();
  }

  ngAfterViewInit() {
    if (window.innerWidth > 575) {
      this.searchFocus.nativeElement.focus();
    }
  }
  showValue(user: User): string {
    return user && user.text ? user.text : "";
  }
  getSearchData(e) {
    this.model.search_value.name = e.text;
    this.search("newSearch");
  }
  private _filter(name: string): User[] {
    const filterValue = name.toLowerCase();
    if (this.options[0] == null) {
      return this.options.filter(
        (option) => option.text.toLowerCase().indexOf(filterValue) === 0
      );
    }
  }

  setSuggetion(from) {
    if (this.options.length > 0 || from === "remove") {
      this.filteredOptions = this.myControl.valueChanges.pipe(
        startWith(""),
        map((value) => (typeof value === "string" ? value : value.name)),
        map(
          (name) => (
            name ? this._filter(name) : this.moviesData.slice(),
            this.seriesData.slice(),
            this.albumData.slice()
          )
        )
      );
    }
  }

  getSuggationData(value) {
    this.moviesSpinner = true;
    this.moviesData = [];
    this.seriesData = [];
    this.albumData = [];
    if (value.text) {
      value = value.text;
    }
    if (!value) {
      if (this.autoTrigger) {
        this.autoTrigger.closePanel();
        this.isSearch = false;
      }
    }
    this.searchStatus = false;
    const typeMovie = { offset: 0, limit: 20, search: value, type: "movies" };
    const typeSeries = { offset: 0, limit: 20, search: value, type: "series" };
    const typeMusic = { offset: 0, limit: 20, search: value, type: "album" };

    forkJoin({
      responseOne: this.pagesService.suggetionService(typeMovie),
      responseTwo: this.pagesService.suggetionService(typeSeries),
      // responseThree: this.pagesService.suggetionService(typeMusic),
    }).subscribe(
      ({ responseOne, responseTwo }) => {
        if (responseOne.results.length > 0) {
          this.moviesSpinner = false;
          this.moviesData = this.options.concat(responseOne.results);
        } else {
          this.moviesSpinner = false;
        }
        if (responseTwo.results.length > 0) {
          this.seriesData = this.options.concat(responseTwo.results);
        }
        // if (responseThree.results.length > 0) {
        //   this.albumData = this.options.concat(responseThree.results);
        // }

        // this.setSuggetion("");
      },
      (err) => {
        if (err.status === 0) {
          this.toastr.error("CONNECTION REFUSED", "Whoops!", {
            closeButton: true,
          });
        } else if (err.status === 500) {
          this.toastr.error(err.statusText, "Whoops!", {
            closeButton: true,
          });
        } else if (err.status === 404) {
          this.toastr.error(err.statusText, "Whoops!", {
            closeButton: true,
          });
        } else if (err.status === 401) {
          this.toastr.error(err.statusText, "Whoops!", {
            closeButton: true,
          });
        } else {
          this.toastr.error(err.statusText, "Whoops!", {
            closeButton: true,
          });
        }
      }
    );
  }
  // click()
  // {
  //   this.searchbox = !this.searchbox
  // }

  search(from) {
    this.shimmerStatus.search = true;
    if (from === "newSearch") {
      this.next_data = "";
      this.searchContent = [];
    }
    if (this.model.search_value) {
      this.isSearch = true;
      this.searchStatus = true;
      const sendData = {
        search_data: this.model.search_value.name,
        next_data: this.next_data,
      };
      if (!this.model.search_value.name) {
        sendData.search_data = this.model.search_value;
      }

      if (sendData.search_data.trim()) {
        this.pagesService.searchContent(sendData).subscribe(
          (res) => {
            if (res.results.length > 0) {
              this.searchContent = this.searchContent.concat(res.results);
            }
            this.searchCount = res.count;
            this.responseData = res;
            this.shimmerStatus.search = false;
            this.next_data = res.next_data;
            if (localStorage.getItem(environment.localStorageKey)) {
              this.saveSuggation(sendData.search_data);
            }
          },
          (err) => {
            this.shimmerStatus.search = false;
            if (err.status === 0) {
              this.toastr.error("CONNECTION REFUSED", "Whoops!", {
                closeButton: true,
              });
            } else if (err.status === 500) {
              this.toastr.error(err.statusText, "Whoops!", {
                closeButton: true,
              });
            } else if (err.status === 404) {
              this.toastr.error(err.statusText, "Whoops!", {
                closeButton: true,
              });
            } else if (err.status === 401) {
              this.toastr.error(err.statusText, "Whoops!", {
                closeButton: true,
              });
            } else {
              this.toastr.error(err.statusText, "Whoops!", {
                closeButton: true,
              });
            }
          }
        );
      } else {
        this.isSearch = false;
        this.searchStatus = false;
      }
    }
  }

  saveSuggation(searchValue) {
    if (searchValue.trim() > 0) {
      const sendData = { text: searchValue };

      this.pagesService.addSuggation(sendData).subscribe(
        (res) => {
          const index = this.options.findIndex(
            (p) => p.text.toLowerCase() === searchValue.toLowerCase()
          );
          if (index === -1) {
            this.options.unshift({
              text: searchValue,
              _id: res.results._id,
              is_deleted: "yes",
            });
          }

          // this.setSuggetion("");
        },
        (err) => {
          if (err.status === 0) {
            this.toastr.error("CONNECTION REFUSED", "Whoops!", {
              closeButton: true,
            });
          } else if (err.status === 500) {
            this.toastr.error(err.statusText, "Whoops!", {
              closeButton: true,
            });
          } else if (err.status === 404) {
            this.toastr.error(err.statusText, "Whoops!", {
              closeButton: true,
            });
          } else if (err.status === 401) {
            this.toastr.error(err.statusText, "Whoops!", {
              closeButton: true,
            });
          } else {
            this.toastr.error(err.statusText, "Whoops!", {
              closeButton: true,
            });
          }
        }
      );
    }
  }
  resetSearch() {
    this.count = 0;
    this.isSearch = false;
    this.searchStatus = false;
    this.model.search_value = "";
  }

  recentSearch(recentvideo) {
    this.shimmerStatus.isResent = false;
    let list = [];
    if (localStorage.getItem("recentVideo")) {
      list = JSON.parse(localStorage.getItem("recentVideo"));
      list.map((el) => {
        if (el.public_id != recentvideo.public_id) {
          list.unshift(recentvideo);
          localStorage.setItem("recentVideo", JSON.stringify(list));
        }
      })
    } else {
      list.unshift(recentvideo);
      localStorage.setItem("recentVideo", JSON.stringify(list));
    }
    setTimeout(() => {
      this.router.navigate(["/video-detail", recentvideo.public_id]);
    }, 100);
  }
  removeText(index, textId, e) {
    this.setSuggetion("remove");
    e.stopPropagation();
    const sendData = { id: textId };

    this.pagesService.removeSuggation(sendData).subscribe();
  }
  getGenereData() {
    if (
      localStorage.getItem(environment.pagesLocalStorageKey) &&
      JSON.parse(localStorage.getItem(environment.pagesLocalStorageKey))
        .map((el) => {
          return el.hasOwnProperty("genres");
        })
        .indexOf(true) != -1
    ) {
      const localdata = JSON.parse(
        localStorage.getItem(environment.pagesLocalStorageKey)
      );
      const index = localdata
        .map((el) => {
          return el.hasOwnProperty("genres");
        })
        .indexOf(true);

      this.genereContent = localdata[index]["genres"].results;

      this.shimmerStatus.genere = false;
    } else {
      const count = true;
      this.pagesService.genereDataService(count).subscribe(
        (res) => {
          this.genereContent = res.results;
          this.shimmerStatus.genere = false;
          if (!localStorage.getItem(environment.pagesLocalStorageKey)) {
            const localdata = [{ ["genres"]: res }];
            localStorage.setItem(
              environment.pagesLocalStorageKey,
              JSON.stringify(localdata)
            );
          } else {
            const localdata = JSON.parse(
              localStorage.getItem(environment.pagesLocalStorageKey)
            );
            localdata.push({ ["genres"]: res });
            localStorage.setItem(
              environment.pagesLocalStorageKey,
              JSON.stringify(localdata)
            );
          }
        },
        (err) => {
          if (err.status === 0) {
            this.toastr.error("CONNECTION REFUSED", "Whoops!", {
              closeButton: true,
            });
          } else if (err.status === 500) {
            this.toastr.error(err.statusText, "Whoops!", {
              closeButton: true,
            });
          } else if (err.status === 404) {
            this.toastr.error(err.statusText, "Whoops!", {
              closeButton: true,
            });
          } else if (err.status === 401) {
            this.toastr.error(err.statusText, "Whoops!", {
              closeButton: true,
            });
          } else {
            this.toastr.error(err.statusText, "Whoops!", {
              closeButton: true,
            });
          }
        }
      );
    }
  }

  onScroll() {
    if (
      this.responseData.results.length > 0 &&
      this.shimmerStatus.search === false
    ) {
      this.search("pagination");
    }
  }
  focusFunction() {
    this.searchBox = true;
  }

  onKey() {
    this.searchBox = false;
  }
  isOpened() {
    this.searchBox = true;
  }
  isClosed() {
    this.searchBox = false;
  }
}
